<template>
  <!-- 解决方案详情 -->
  <div class="SolutionDetails" v-loading="loading">
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>解决方案</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span @click="goToHome" class="clickable">首页&nbsp;></span>
          <span @click="goToSolution" class="clickable">解决方案&nbsp;></span>
          <span>解决方案详情</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <div class="solutionContentBox">
          <div v-if="item && item.innerText" v-html="item.innerText"></div>
          <div v-else class="no-data">
            <p>暂无解决方案详情数据</p>
            <el-button type="primary" @click="goToHome">返回首页</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Plan from "@/api/plan.js";

export default {
  name: "SolutionDetails",
  data() {
    return {
      item: {},
      loading: false
    };
  },
  methods: {
    // 返回首页
    goToHome() {
      this.$LocalCache.setCath("navigationBarIndex", 0);
      this.$router.push({ name: 'Home' });
    },
    // 返回解决方案
    goToSolution() {
      this.$LocalCache.setCath("navigationBarIndex", 2);
      this.$router.push({ name: 'Solution' });
    },
    // 获取解决方案详情
    async getSolutionDetail(planDataCenterId) {
      this.loading = true;
      try {
        const { code, msg, data } = await Plan.getDetail({ planDataCenterId });
        if (code === 200) {
          this.item = data;
          // 等待DOM更新后处理图片
          this.$nextTick(() => {
            this.handleImages();
          });
        } else {
          this.$message.error(msg || '获取解决方案详情失败');
        }
      } catch (error) {
        console.error('获取解决方案详情失败:', error);
        this.$message.error('获取解决方案详情失败');
      } finally {
        this.loading = false;
      }
    },
    // 处理图片尺寸
    handleImages() {
      // 不需要任何JavaScript处理，直接通过CSS统一控制
    }
  },
  mounted() {
    // 获取解决方案详情
    const planDataCenterId = this.$route.query.planDataCenterId;
    if (planDataCenterId) {
      this.getSolutionDetail(planDataCenterId);
    } else {
      this.$message.error('缺少解决方案ID参数');
      // 返回解决方案页面
      this.goToSolution();
    }

    // 页面加载后自动滚动到内容区域的合适位置
    this.$nextTick(() => {
      // 滚动到面包屑导航的位置，让用户能看到完整的导航和内容
      const breadcrumb = document.querySelector('.breadcrumb');
      if (breadcrumb) {
        const bannerHeight = 274; // banner的固定高度
        const scrollOffset = 20; // 额外的偏移量，确保面包屑完全可见

        window.scrollTo({
          top: bannerHeight - scrollOffset,
          behavior: 'smooth'
        });
      }
    });
  }
};
</script>

<style scoped lang="scss">
.SolutionDetails {
  width: 100%;

  ::globel(img) {
    width: 100% !important;
  }
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }

        &:nth-child(3) {
          color: #2b8737;
        }

        &.clickable {
          cursor: pointer;

          &:hover {
            opacity: 0.7;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 20px 0 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      max-width: 100%;
      padding: 0 20px;
      margin: 0 auto;
      .solutionContentBox {
        width: 100%;
        background-color: #fff;
        padding: 40px;
        min-height: 800px;

        // 设置内容区域的统一宽度
        $content-width: 1000px;
        $content-width-medium: 800px;
        $content-width-small: 100%;

        // 所有内容元素的基础样式
        :deep(*) {
          box-sizing: border-box;
        }

        // 图片容器样式 - 与文字完全一致的宽度
        :deep(p:has(img)) {
          width: 100%;

          img {
            width: 100%;
          }
        }

        // 文字段落样式 - 与图片完全一致的宽度
        :deep(p:not(:has(img))) {
          width: 100%;
        }

        // 标题样式 - 与图片文字完全一致的宽度
        :deep(h1, h2, h3, h4, h5, h6) {
          width: 100%;
          max-width: $content-width;
          margin: 20px auto;
          padding: 0 20px;
          box-sizing: border-box;
        }

        // 表格样式 - 与图片文字完全一致的宽度
        :deep(table) {
          width: 100%;
          max-width: $content-width;
          margin: 20px auto;
          box-sizing: border-box;
        }

        // 列表样式 - 与图片文字完全一致的宽度
        :deep(ul, ol) {
          width: 100%;
          max-width: $content-width;
          margin: 16px auto;
          padding: 0 20px;
          box-sizing: border-box;
        }

        // 响应式调整 - 中等屏幕
        @media screen and (max-width: 1200px) {
          padding: 30px;

          :deep(p:has(img)) {
            width: 100%;

            img {
              width: 100%;
            }
          }

          :deep(p:not(:has(img))) {
            width: 100%;
          }

          :deep(h1, h2, h3, h4, h5, h6) {
            max-width: $content-width-medium;
            padding: 0 15px;
          }

          :deep(table) {
            max-width: $content-width-medium;
          }

          :deep(ul, ol) {
            max-width: $content-width-medium;
            padding: 0 15px;
          }
        }

        // 响应式调整 - 小屏幕
        @media screen and (max-width: 768px) {
          padding: 20px;

          :deep(p:has(img)) {
            width: 100%;

            img {
              width: 100%;
            }
          }

          :deep(p:not(:has(img))) {
            width: 100%;
          }

          :deep(h1, h2, h3, h4, h5, h6) {
            max-width: $content-width-small;
            margin: 15px auto;
            padding: 0 10px;
          }

          :deep(table) {
            max-width: $content-width-small;
          }

          :deep(ul, ol) {
            max-width: $content-width-small;
            padding: 0 10px;
          }
        }

        .no-data {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 400px;

          p {
            font-size: 18px;
            color: #666666;
            margin-bottom: 20px;
          }

          .el-button {
            background-color: #2b8737;
            border-color: #2b8737;

            &:hover {
              background-color: #1e7f29;
              border-color: #1e7f29;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/solutionDetails/SolutionDetails.vue